import {Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'roundResult' })
export class RoundResultPipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 0:
        return 'HIGH';
      case 1:
        return 'LOW';
      case 2:
        return 'DRAW';
      case 3:
        return 'ERROR';
      default:
        return '';
    }
  }
}
